"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M5 4.5h14.015c.242 0 .438.196.438.438v7.883a.438.438 0 0 1-.438.438H5a.438.438 0 0 1-.438-.438V4.938c0-.242.197-.438.438-.438Zm.438 7.883h13.14V5.376H5.437v7.007h.001Zm-5-7.531h2.803c.242 0 .438.196.438.438v8.408a.438.438 0 0 1-.438.438h-.964v4.38h.526a.438.438 0 1 1 0 .876H.876a.438.438 0 1 1 0-.876H1.4v-4.38H.438A.438.438 0 0 1 0 13.698V5.29c0-.242.196-.438.438-.438Zm.438 8.408h1.927V5.727H.876v7.533Zm1.175-.82a.539.539 0 0 0 .016-1.014.539.539 0 0 0-.427.017.54.54 0 0 0 .41.998l.001-.001Zm.293-5.61a.54.54 0 1 1-.983.447.54.54 0 0 1 .983-.447ZM2.05 9.995a.54.54 0 1 0-.68-.704.54.54 0 0 0 .68.704Zm18.707-5.143h2.803c.242 0 .438.196.438.438v8.408a.438.438 0 0 1-.438.438h-.963v4.38h.525a.438.438 0 1 1 0 .876h-1.927a.438.438 0 1 1 0-.876h.526v-4.38h-.964a.438.438 0 0 1-.438-.438V5.29c0-.242.197-.438.438-.438Zm.438 8.408h1.927V5.727h-1.927v7.533Zm.969-.775a.54.54 0 1 0-.001-1.08.54.54 0 0 0 .001 1.08Zm.54-5.445a.54.54 0 1 1-1.08 0 .54.54 0 0 1 1.08 0Zm-.54 2.992a.54.54 0 1 0 0-1.08.54.54 0 0 0 0 1.08ZM5 15.016h14.015c.242 0 .438.196.438.438v3.503a.438.438 0 0 1-.438.438H5a.438.438 0 0 1-.438-.438v-3.503c0-.242.197-.438.438-.438Zm9.373 2.627h-4.73v.876h4.73v-.876Zm-4.73-.876h4.73v-.875h-4.73v.875Zm-.876-.875H5.438v2.627h3.329v-2.627Zm6.482 2.627h3.328v-2.627H15.25v2.627h-.001Z",
    clipRule: "evenodd"
  })]
});